import { http } from '@shared/api/http-client';
import type { SubscriptionPlan } from '@features/plans/model/plan.types';

export const planApi = {
  /** The whole catalogue — retired plans included — in the product's own order. */
  list(): Promise<SubscriptionPlan[]> {
    return http.get<SubscriptionPlan[]>('/budgeting/plans');
  },
};
